import styled from 'styled-components';
import { useCallback } from 'react';
import { getSpacingToken, getToken, Icon, IconName } from '@optimus-web/core';

interface ClearSelectionButtonProps {
    handleClick: () => void;
}

export const ClearSelectionButton = ({ handleClick }: ClearSelectionButtonProps) => {
    const handleKeyDown = useCallback(
        (e: React.KeyboardEvent<HTMLDivElement>) => {
            if (e.key === 'Enter') {
                handleClick();
                e.stopPropagation();
                e.preventDefault();
            }
        },
        [handleClick]
    );

    return (
        <ClearSelectionButtonContainer tabIndex={0} onClick={handleClick} onKeyDown={handleKeyDown}>
            <Icon value={IconName.ClearSelection} variant="inherit" size="small" />
        </ClearSelectionButtonContainer>
    );
};

const ClearSelectionButtonContainer = styled.div`
    cursor: pointer;
    z-index: 10;
    color: ${getToken('backgroundInteractiveNeutralHover')};
    height: ${getSpacingToken('150')}px;

    &:hover {
        color: ${getToken('backgroundInteractiveNeutralActive')};
    }
`;
